import { Bento } from "../components/Bento";
import { t } from "@/i18n-js/instance";
import TotalRevenueEarned from "./assets/total-revenue-earned.png";
import RevenueGrowthYearOverYear from "./assets/revenue-growth-yoy.png";
import { SanitizeHTMLString } from "@/react/components/shared/uikit/SanitizeContent";
import { abbreviateNumber } from "@/react/helpers/number";

const i18nRoot = "eoy_recap_2025.sections.impact";

import type { BusinessImpactMetrics } from "../../types";
import { MonthsDisplay } from "./Months";
import { BestSellingProductCard } from "./BestSellingProductCard";

interface ImpactProps {
  data?: BusinessImpactMetrics;
}

export const Impact = ({ data }: ImpactProps) => {
  if (!data) return null;

  return (
    <Bento
      id="business-impact"
      accentColor="#FF8D46"
      title={t([i18nRoot, "title"])}
    >
      <Bento.Item id="total-revenue-earned" baseColSpan={1} baseRowSpan={3}>
        <div className="flex flex-col h-full overflow-hidden">
          <div className="p-8">
            <p className="text-4xl md:text-6xl font-bold mb-2 leading-11">
              {abbreviateNumber(data.total_revenue_earned)}
            </p>
            <p className="text-base font-medium leading-none tracking-[-0.25px] text-white mb-4">
              {t([i18nRoot, "bento_items.total_revenue_earned"])}
            </p>
          </div>
          <div className="flex-1 min-h-0 overflow-hidden rounded-b-2xl">
            <img
              src={TotalRevenueEarned}
              alt={t([i18nRoot, "bento_items.total_revenue_earned"])}
              className="size-full object-cover"
              loading="lazy"
            />
          </div>
        </div>
      </Bento.Item>
      <Bento.Item
        id="revenue-growth-year-over-year"
        baseColSpan={1}
        baseRowSpan={3}
      >
        <div className="flex flex-col h-full overflow-hidden">
          <div className="px-8 pt-8">
            <p className="text-4xl md:text-6xl font-bold mb-2 leading-11">
              {abbreviateNumber(data.revenue_growth_year_over_year)}%
            </p>
            <p className="text-base font-medium leading-none tracking-[-0.25px] text-white mb-4">
              {t([i18nRoot, "bento_items.revenue_growth_yoy"])}
            </p>
          </div>
          <div className="flex-1 min-h-0 overflow-hidden rounded-b-2xl">
            <img
              src={RevenueGrowthYearOverYear}
              alt={t([i18nRoot, "bento_items.revenue_growth_yoy"])}
              className="size-full object-cover"
              loading="lazy"
            />
          </div>
        </div>
      </Bento.Item>
      <Bento.Item id="best-selling-product" baseColSpan={1} baseRowSpan={3}>
        <div className="flex flex-col h-full overflow-hidden p-8 gap-4">
          <p className="text-4xl font-bold mb-2 text-center leading-8">
            <SanitizeHTMLString
              content={t([
                i18nRoot,
                "bento_items.best_selling_product_or_course",
              ])}
            />
          </p>
          <BestSellingProductCard product={data.best_selling_product} />
        </div>
      </Bento.Item>
      <Bento.Item id="highest-earning-month" baseColSpan={3} baseRowSpan={2}>
        <div className="flex flex-row justify-between size-full overflow-hidden">
          <div className="p-8">
            <p className="font-sans text-[32px] font-bold leading-none tracking-[-1.5px] text-[#FAFAFA]">
              <SanitizeHTMLString
                content={t([i18nRoot, "bento_items.highest_earning_month"])}
              />
            </p>
          </div>
          <div className="pr-8">
            <MonthsDisplay month={data.highest_earning_month} />
          </div>
        </div>
      </Bento.Item>
    </Bento>
  );
};
